import type { FlagValue } from '@anchorage/feature-flags';
import { Input } from '@latitude/input';
import React from 'react';

import { FlagActions } from './FlagActions';

type StringNumberFlagInputProps = {
  flagKey: string;
  type: 'string' | 'number';
  displayValue: FlagValue;
  isOverridden: boolean;
  defaultValue: FlagValue | undefined;
  hasUnsavedChanges: boolean;
  onChange: (key: string, value: FlagValue) => void;
  onReset: (key: string) => void;
  onSave: (key: string) => void;
};

export const StringNumberFlagInput: React.FC<StringNumberFlagInputProps> = ({
  flagKey,
  type,
  displayValue,
  isOverridden,
  defaultValue,
  hasUnsavedChanges,
  onChange,
  onReset,
  onSave,
}) => {
  return (
    <div className="space-y-2">
      <Input
        value={String(displayValue)}
        onChange={(e) => {
          const newValue =
            type === 'number' ? Number(e.target.value) : e.target.value;
          onChange(flagKey, newValue);
        }}
        type={type === 'number' ? 'number' : 'text'}
        clearable={false}
      />
      <FlagActions
        flagKey={flagKey}
        isOverridden={isOverridden}
        hasUnsavedChanges={hasUnsavedChanges}
        formattedDefaultValue={String(defaultValue)}
        onReset={onReset}
        onSave={onSave}
      />
    </div>
  );
};
